/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/*
NAME: EquipmentsList
DESC: Componente responsavel por renderizar a lista de equipamentos
props:
- items: Array de objetos que representa a lista de equipamentos
- usuarioLogado: Tipo de ususario logado
- loading: Boolean que indica se a lista esta carregando ou nao
- RowsPerPage: Quantidade de linhas por pagina da tabela que será exibida
-refresh: Função que vem de um componente pai para atualizar a lista de usuarios através de um get

- - - - Default

NOTES:

*/

import React, {useState, useEffect}from 'react';
import strings from '../../values/strings/strings';
import ProjectTable from '../basic/ProjectTable';
import { IconButton } from '@mui/material';
import { Info, KeyboardReturnSharp } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useHistory } from 'react-router';
import Pages from '../../pages/Pages';
import DateFormat from '../../usecases/DateFormat';
import UserTypes from '../../models/UserTypes';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Tooltip from '@mui/material/Tooltip';

function EquipmentsDashboardList({items, usuario, usuarioLogado, loading, RowsPerPage, refresh }) {

    const [headers, setheaders] = useState(['Info',"Status", `${strings.getString('info_name')}`, `${strings.getString('info_ultimate_registred')}` , "Id"]);
    const [tableItems, setTableItems] = useState([])
    const [usuarioLogado1, setUsuarioLogado] = useState(null) 
    const [status, setStatus] = useState([])
    

    const history = useHistory();

    useEffect(() => {    
        
        if(usuarioLogado && usuarioLogado.tipo !== UserTypes.CLI && headers[2] !== "Usuário"){
            let headersNew = [...headers]
            headersNew = [...headers.slice(0,2),...headers.slice(2,headers.length)] 
            setheaders(headersNew)        
        }    
        setUsuarioLogado(usuarioLogado)  
        
    }, [usuarioLogado])

    useEffect(() => {
        if(items){
        let items1 = items 
        let EquipamentTabela = bindData(items1)
        setTableItems(EquipamentTabela) 
    }
    } , [items])

    function cadastroEquipamento(item){
        history.push(Pages.routes.Equipments + "/" + item.id)
    }
    
 
    function redirectEquipament(item){        
        history.push(Pages.routes.Equipments + "/" + item.device_id)
    }

    function redirectMonitor(item){
        history.push(Pages.routes.Monitor + "/" + item.id)
    }

    function zoom(item){
       alert('Função Vazia')
    }

    function redirectUser(item){
        history.push(Pages.routes.Users + "/" +item.usuario_id) 
    }
    
    function infoWorks(item){
        return <IconButton color="info" onClick={() => cadastroEquipamento(item)}><Info/></IconButton>
    }


  
    const bindData = (data) => {       
        
        let binded = []

        /*let orderData = data.sort((a, b) => {
            return new Date(b.data_update_server).getTime() - new Date(a.data_update_server).getTime()
        })*/

        binded = data.map((item, index) => {
            //let userName = item.usuario_id && usuario.nome ? usuario.nome : 'Sem Usuário';
            
             let obj = {}
            obj.info =  <Tooltip title="Ver informações" >{infoWorks(item)}</Tooltip>
            obj.status = <Tooltip title="Mostar no mapa">{itemStatus(item)}</Tooltip>
            //if(usuarioLogado && usuarioLogado.tipo !== UserTypes.CLI) obj.usuario =<Button  onClick={()=>redirectUser(item)}> {item.usuario.nome} </Button>
            obj.nome = <Button  onClick={()=>redirectEquipament(item)}> {item.nome} </Button> //#TODO - Adicionar o nome do usuario dono de determinado equipamento
            obj.ultimoregistro = DateFormat(new Date(item.data_update_server))
            obj.id = item.device_id
            return obj
        })
        return binded
    } 


    function detalhesEquipamento(item) {
      history.push(Pages.routes.Equipments)
     
    }
    function itemStatus(item){
      //#TODO  - falta ser adicionado no array de objetos o status do equipamento
        item.status = 'Conectado'
            if(item.status === 'Conectado'){
                return <IconButton color='success'  onClick={() => zoom(item)}><LocationOnIcon/></IconButton>
            } else {
                return  <Button onClick={() => zoom(item)} disabled ><LocationOnIcon  /></Button>
            }
        }
              

    return (
       
        <ProjectTable 
            loading={loading} 
            rowsPerPage={RowsPerPage}
            style={{flex:1, width:'100%', maxWidth:'100%'}} 
            onViewMore={detalhesEquipamento} 
            title={strings.getString('default_equipament_title_situation')}  
            headers={headers} 
            items={tableItems} 
            onRefresh={refresh}
        />

    );
   
}

export default EquipmentsDashboardList;

